export default "__VITE_ASSET__1df2b3cf__"